module.exports = __webpack_public_path__ + "static/media/shareLockGuide6_Jap.59ca7aad.jpg";